export default __webpack_public_path__ + "static/media/bgr-login.9184142b.png";